import * as React from 'react'
import { Row, Label } from 'reactstrap';
import { IAlertInsights } from '../types';
import * as numeral from 'numeral'
export interface IAlertsInsightsProps {
  isEdit: boolean
  alertId?: string
  caseId?: string;
  data?: IAlertInsights
}

export interface IAlertsInsightsState {
}

export default class AlertsInsights extends React.PureComponent<IAlertsInsightsProps, IAlertsInsightsState> {
  constructor(props: IAlertsInsightsProps) {
    super(props);
  }
  public render() {
    const available = !!this.props.data && this.props.data.impresions > 0;
    const data = this.props.data || { impresions: 0, clicks: 0 };

    return this.props.isEdit && !!this.props.alertId ? (
      <>
        <Row>
          <h5>{available ? "Alert insights:" : "Alert insights not available yet"}</h5>
        </Row>
        {
          available &&
          <Row className="marginTop">
            <Label className={"text-center"}>{numeral(data.impresions).format('0,0')} <p>Impressions</p></Label>
            <Label className={"text-center"}>{numeral(data.clicks).format('0,0')} <p>Clicks</p> </Label>
          </Row>
        }
        {!!this.props.caseId &&
          <Row>
            <Label className={"text-center google-statistics-redirect"}>
              <p onClick={() => window.open(`/alerts/stats/${this.props.caseId}/${this.props.alertId}`)}>
                Click here for more statistics<i className="fas fa-external-link-alt" />
              </p>
            </Label>
          </Row>}
      </>
    ) : false
  }
}



// WEBPACK FOOTER //
// ./src/modules/Alert/Create/components/Stats.tsx